const MCC = [
    { value: "5960", label: "保险直销（代扣）" },
    { value: "6300", label: "保险公司" },
    { value: "6301", label: "保险代理" },
    { value: "3004", label: "私立大学与学院" },
    { value: "4905", label: "图书馆" },
    { value: "8049", label: "公立社区卫生服务中心、卫生院" },
    { value: "8062", label: "公立医院" },
    { value: "8211", label: "公立中小学校" },
    { value: "8220", label: "公立大学与学院" },
    { value: "8351", label: "公立儿童保育服务（学前教育）" },
    { value: "8398", label: "慈善和社会公益服务" },
    { value: "8651", label: "政府机构" },
    { value: "9211", label: "法庭费用" },
    { value: "9222", label: "行政费用和罚款" },
    { value: "9223", label: "保释金" },
    { value: "9311", label: "税务、海关" },
    { value: "9399", label: "社会保障服务" },
    { value: "9405", label: "政府采购" },
    { value: "9411", label: "政府贷款" },
    { value: "9715", label: "档案" },
    { value: "9752", label: "电子档案" },
    { value: "4784", label: "路桥通行费" },
    { value: "4900", label: "公共事业（电、气、水）" },
    { value: "4901", label: "公共事业-电力缴费" },
    { value: "4902", label: "公共事业-煤气缴费" },
    { value: "4903", label: "公共事业-自来水缴费" },
    { value: "4908", label: "其他缴费" },
    { value: "3000", label: "私立中小学校" },
    { value: "3001", label: "私立儿童保育服务（学前教育）" },
    { value: "8298", label: "少年宫及青少年发展中心" },
    { value: "8299", label: "其他学校和教育服务" },
    { value: "4513", label: "机票平台" },
    { value: "4514", label: "航空系统商" },
    { value: "4816", label: "互联网IDC服务" },
    { value: "5734", label: "计算机软件" },
    { value: "5816", label: "数字类产品游戏（国际专用）" },
    { value: "5817", label: "数字类产品软件提供商" },
    { value: "5818", label: "数字类产品其他（国际专用）" },
    { value: "7372", label: "软件系统商" },
    { value: "7373", label: "网络论坛" },
    { value: "7374", label: "门户网站" },
    { value: "7375", label: "信息检索服务（信息平台）" },
    { value: "7408", label: "网站设计、推广" },
    { value: "7409", label: "SNS社交网站" },
    { value: "7410", label: "休闲游戏" },
    { value: "7411", label: "在线文学类" },
    { value: "7412", label: "手机图铃" },
    { value: "7413", label: "其他在线应用或综合类" },
    { value: "7414", label: "视频点播" },
    { value: "7954", label: "网络游戏点卡、渠道代理" },
    { value: "7956", label: "游戏系统商" },
    { value: "7957", label: "网游周边服务、交易平台" },
    { value: "7958", label: "网游运营商（含网页游戏）" },
    { value: "8249", label: "职业技能培训" },
    { value: "9950", label: "站内清算" },
    { value: "1520", label: "房地产开发商" },
    { value: "1711", label: "空调类承包商" },
    { value: "1731", label: "电器承包商" },
    { value: "1740", label: "建筑材料承包商" },
    { value: "1750", label: "木工承包商" },
    { value: "1761", label: "金属产品承包商" },
    { value: "1771", label: "混凝土承包商" },
    { value: "1799", label: "其他工程承包商" },
    { value: "2741", label: "出版印刷服务" },
    { value: "2791", label: "刻版排版服务" },
    { value: "2842", label: "清洁抛光服务" },
    { value: "3002", label: "大型企业批发" },
    { value: "3003", label: "铁路局（直属）" },
    { value: "4011", label: "铁路货运" },
    { value: "4111", label: "公共交通" },
    { value: "4112", label: "铁路客运" },
    { value: "4113", label: "ETC不停车自动缴费" },
    { value: "4114", label: "MTC半自动车道收费" },
    { value: "4115", label: "地铁" },
    { value: "4119", label: "急救服务" },
    { value: "4121", label: "出租车服务（TAXI）" },
    { value: "4131", label: "长途公路客运" },
    { value: "4214", label: "物流货运服务" },
    { value: "4215", label: "快递服务" },
    { value: "4225", label: "公共仓储、集装整理" },
    { value: "4411", label: "游轮及巡游航线服务" },
    { value: "4457", label: "出租船只" },
    { value: "4468", label: "船舶、海运服务提供商" },
    { value: "4511", label: "航空公司" },
    { value: "4512", label: "机票代理人" },
    { value: "4582", label: "机场服务" },
    { value: "4722", label: "旅行社和旅游服务" },
    { value: "4723", label: "国际货运代理和报关行" },
    { value: "4733", label: "大型旅游景点" },
    { value: "4789", label: "未列入其他代码的运输服务" },
    { value: "4812", label: "手机、通讯设备销售" },
    { value: "4814", label: "电信运营商" },
    { value: "4815", label: "话费充值与缴费" },
    { value: "4821", label: "网络电话、传真" },
    { value: "4829", label: "电汇和汇票服务" },
    { value: "4899", label: "付费电视" },
    { value: "4904", label: "公共事业-清洁服务缴费" },
    { value: "4906", label: "充电桩" },
    { value: "4909", label: "有线电视缴费" },
    { value: "5013", label: "机动车供应及零配件（批发商）" },
    { value: "5021", label: "办公及商务家具（批发商）" },
    { value: "5039", label: "未列入其他代码的建材（批发商）" },
    { value: "5044", label: "办公、影印及微缩摄影器材（批发商）" },
    { value: "5045", label: "商用计算机及服务器" },
    { value: "5046", label: "未列入其他代码的商用器材" },
    { value: "5047", label: "医疗器械" },
    { value: "5051", label: "金属产品和服务（批发商）" },
    { value: "5065", label: "电气产品和设备" },
    { value: "5072", label: "五金器材及用品（批发商）" },
    { value: "5074", label: "管道及供暖设备" },
    { value: "5085", label: "工业设备和制成品" },
    { value: "5094", label: "珠宝和金银饰品" },
    { value: "5099", label: "其他工业耐用品" },
    { value: "5111", label: "文具、办公用品、复印纸和书写纸（批发商）" },
    { value: "5122", label: "药品、药品经营者（批发商）" },
    { value: "5131", label: "布料、缝纫用品和其他纺织品（批发商）" },
    { value: "5137", label: "制服与商务正装定制" },
    { value: "5139", label: "鞋类销售平台（批发商）" },
    { value: "5169", label: "化工产品" },
    { value: "5172", label: "石油及石油产品（批发商）" },
    { value: "5192", label: "书、期刊和报纸（批发商）" },
    { value: "5193", label: "花木栽种用品、苗木和花卉（批发商）" },
    { value: "5198", label: "油漆、清漆用品（批发商）" },
    { value: "5199", label: "其他工业原料和消耗品" },
    { value: "5200", label: "大型仓储式家庭用品卖场" },
    { value: "5211", label: "木材与建材商店" },
    { value: "5231", label: "玻璃、油漆涂料、墙纸" },
    { value: "5251", label: "家用五金工具" },
    { value: "5261", label: "草坪和花园用品" },
    { value: "5271", label: "活动房车销售商" },
    { value: "5300", label: "会员制批量零售店" },
    { value: "5309", label: "国外代购及免税店" },
    { value: "5310", label: "团购及折扣店" },
    { value: "5311", label: "平台类综合商城" },
    { value: "5331", label: "杂货店" },
    { value: "5399", label: "其他综合零售" },
    { value: "5411", label: "超市（非平台类）" },
    { value: "5422", label: "肉、禽、蛋及水产品" },
    { value: "5423", label: "水果店" },
    { value: "5441", label: "糖果及坚果商店" },
    { value: "5451", label: "乳制品/冷饮" },
    { value: "5462", label: "面包糕点" },
    { value: "5466", label: "茶叶" },
    { value: "5467", label: "保健品" },
    { value: "5499", label: "其他食品零售" },
    { value: "5511", label: "汽车销售" },
    { value: "5521", label: "二手车销售" },
    { value: "5531", label: "汽车商店、家庭用品商店（国际专用）" },
    { value: "5532", label: "汽车轮胎经销" },
    { value: "5533", label: "汽车零配件" },
    { value: "5541", label: "加油站、服务站" },
    { value: "5542", label: "加油卡、加油服务" },
    { value: "5551", label: "船舶及配件销售" },
    { value: "5561", label: "拖车、篷车及娱乐用车" },
    { value: "5564", label: "轨道交通设备器材" },
    { value: "5565", label: "飞机及配件、航道设施" },
    { value: "5566", label: "运输搬运设备、起重装卸设备" },
    { value: "5571", label: "摩托车及配件" },
    { value: "5572", label: "电动车及配件" },
    { value: "5592", label: "露营及旅行汽车" },
    { value: "5598", label: "雪车" },
    { value: "5599", label: "机动车综合经营" },
    { value: "5611", label: "男性服饰" },
    { value: "5621", label: "女性成衣" },
    { value: "5631", label: "配饰商店" },
    { value: "5641", label: "母婴用品" },
    { value: "5651", label: "内衣/家居服" },
    { value: "5655", label: "运动服饰" },
    { value: "5661", label: "鞋类" },
    { value: "5681", label: "皮草皮具" },
    { value: "5691", label: "高档时装及奢侈品" },
    { value: "5697", label: "裁缝、修补、改衣制衣" },
    { value: "5698", label: "假发等饰品" },
    { value: "5699", label: "各类服装及饰物" },
    { value: "5712", label: "家具/家庭摆设" },
    { value: "5713", label: "地板和地毯" },
    { value: "5714", label: "窗帘、帷幕、室内装潢" },
    { value: "5715", label: "酒精饮料批发商（国际专用）" },
    { value: "5718", label: "壁炉、屏风" },
    { value: "5719", label: "各种家庭装饰专营" },
    { value: "5722", label: "家用电器" },
    { value: "5732", label: "数码产品及配件" },
    { value: "5733", label: "乐器" },
    { value: "5735", label: "音像制品" },
    { value: "5811", label: "宴会提供商" },
    { value: "5812", label: "餐厅、订餐服务" },
    { value: "5813", label: "酒吧、舞厅、夜总会" },
    { value: "5814", label: "快餐店" },
    { value: "5815", label: "咖啡厅、茶馆" },
    { value: "5880", label: "校园团餐" },
    { value: "5881", label: "综合团餐" },
    { value: "5912", label: "药物" },
    { value: "5914", label: "成人用品/避孕用品/情趣内衣" },
    { value: "5921", label: "酒类" },
    { value: "5931", label: "旧商品店、二手商品店" },
    { value: "5932", label: "文物古董" },
    { value: "5933", label: "典当行" },
    { value: "5935", label: "海上船只遇难救助" },
    { value: "5937", label: "古玩复制品（赝品）" },
    { value: "5940", label: "自行车及配件" },
    { value: "5941", label: "体育用品/器材" },
    { value: "5942", label: "书籍" },
    { value: "5943", label: "文具及办公用品" },
    { value: "5944", label: "钟表店" },
    { value: "5945", label: "玩具、游戏用品" },
    { value: "5946", label: "专业摄影器材" },
    { value: "5947", label: "礼品、卡片、纪念品" },
    { value: "5948", label: "行李箱包" },
    { value: "5949", label: "家用纺织品" },
    { value: "5950", label: "瓷器、玻璃和水晶摆件" },
    { value: "5962", label: "旅游相关服务直销" },
    { value: "5963", label: "上门直销（直销员）" },
    { value: "5964", label: "目录直销平台" },
    { value: "5965", label: "直销代理" },
    { value: "5966", label: "电话外呼直销" },
    { value: "5967", label: "电话接入直销" },
    { value: "5968", label: "订阅订购服务" },
    { value: "5969", label: "直销" },
    { value: "5970", label: "工艺美术用品" },
    { value: "5971", label: "艺术品和画廊" },
    { value: "5972", label: "邮票/纪念币" },
    { value: "5973", label: "宗教物品" },
    { value: "5975", label: "助听器" },
    { value: "5976", label: "康复和身体辅助用品" },
    { value: "5977", label: "化妆品" },
    { value: "5978", label: "打字设备、打印复印机、扫描仪" },
    { value: "5983", label: "油品燃料经销" },
    { value: "5984", label: "烟花爆竹" },
    { value: "5992", label: "花店" },
    { value: "5993", label: "烟草/雪茄" },
    { value: "5994", label: "报纸、杂志" },
    { value: "5995", label: "宠物及宠物用品" },
    { value: "5996", label: "游泳、SPA、洗浴设备" },
    { value: "5997", label: "男士用品：剃须刀、烟酒具、瑞士军刀" },
    { value: "5998", label: "帐篷和遮阳篷商店" },
    { value: "5999", label: "其他专业零售店" },
    { value: "6010", label: "金融机构-商业银行服务" },
    { value: "6011", label: "金融机构-自动现金服务" },
    { value: "6012", label: "金融机构-其他服务" },
    { value: "6050", label: "贵金属投资" },
    { value: "6051", label: "外币汇兑" },
    { value: "6060", label: "小贷公司" },
    { value: "6061", label: "消费金融公司" },
    { value: "6062", label: "汽车金融公司" },
    { value: "6063", label: "融资租赁公司" },
    { value: "6064", label: "金融租赁公司" },
    { value: "6065", label: "信托公司" },
    { value: "6066", label: "支付机构" },
    { value: "6067", label: "融资担保公司" },
    { value: "6069", label: "P2P" },
    { value: "6071", label: "自助贩卖机" },
    { value: "6072", label: "自助零售" },
    { value: "6073", label: "自助借还" },
    { value: "6074", label: "自助娱乐服务" },
    { value: "6075", label: "其他自助生活服务" },
    { value: "6211", label: "证券期货基金" },
    { value: "6513", label: "不动产管理－物业管理" },
    { value: "6760", label: "个人资金借贷" },
    { value: "7011", label: "住宿服务（旅馆、酒店、汽车旅馆、度假村等）" },
    { value: "7012", label: "度假用别墅服务" },
    { value: "7013", label: "不动产代理——房地产经纪" },
    { value: "7032", label: "运动和娱乐露营" },
    { value: "7033", label: "活动房车场及野营场所 " },
    { value: "7210", label: "洗衣服务" },
    { value: "7211", label: "洗熨服务（自助洗衣服务）" },
    { value: "7216", label: "干洗店" },
    { value: "7217", label: "室内清洁服务" },
    { value: "7221", label: "摄影服务" },
    { value: "7230", label: "美容/美发服务" },
    { value: "7231", label: "美甲" },
    { value: "7251", label: "鞋帽清洗" },
    { value: "7261", label: "丧仪殡葬服务" },
    { value: "7273", label: "婚介服务" },
    { value: "7276", label: "财务债务咨询" },
    { value: "7277", label: "婚庆服务" },
    { value: "7278", label: "导购、经纪和拍卖服务" },
    { value: "7295", label: "家政服务" },
    { value: "7296", label: "服装出租" },
    { value: "7297", label: "按摩服务" },
    { value: "7298", label: "美容SPA和美体保健" },
    { value: "7299", label: "其他生活服务" },
    { value: "7311", label: "广告服务" },
    { value: "7321", label: "征信和信用报告咨询服务" },
    { value: "7322", label: "债务催收机构" },
    { value: "7333", label: "商业摄影、设计、绘图服务" },
    { value: "7338", label: "复印及绘图服务" },
    { value: "7339", label: "文字处理/翻译速记" },
    { value: "7340", label: "商户拓展" },
    { value: "7342", label: "灭虫及消毒服务" },
    { value: "7349", label: "清洁、保养及门卫服务" },
    { value: "7361", label: "猎头、职业中介" },
    { value: "7379", label: "计算机维护和修理服务" },
    { value: "7392", label: "公关和企业管理服务" },
    { value: "7393", label: "保安和监控服务" },
    { value: "7394", label: "设备、工具、家具和电器出租" },
    { value: "7395", label: "商业摄影摄像服务" },
    { value: "7399", label: "其他商业服务" },
    { value: "7511", label: "货品停放交易(国际专用)" },
    { value: "7512", label: "汽车出租" },
    { value: "7513", label: "卡车及拖车出租" },
    { value: "7519", label: "房车和娱乐车辆出租" },
    { value: "7523", label: "停车服务" },
    { value: "7531", label: "汽车维修、保养、美容装饰" },
    { value: "7534", label: "轮胎翻新、维修" },
    { value: "7535", label: "汽车喷漆店" },
    { value: "7538", label: "汽车改造等服务（非经销商）" },
    { value: "7542", label: "洗车" },
    { value: "7549", label: "拖车服务" },
    { value: "7622", label: "电器维修" },
    { value: "7623", label: "空调、制冷设备维修" },
    { value: "7629", label: "办公电器和小家电维修" },
    { value: "7631", label: "手表、钟表和首饰维修店" },
    { value: "7641", label: "家具维修、翻新" },
    { value: "7692", label: "焊接维修服务" },
    { value: "7699", label: "各类维修相关服务" },
    { value: "7829", label: "艺术创作服务" },
    { value: "7832", label: "电影院及电影票" },
    { value: "7841", label: "音像制品出租" },
    { value: "7911", label: "歌舞厅/夜店" },
    { value: "7922", label: "演出票务服务" },
    { value: "7929", label: "乐队和文艺表演" },
    { value: "7932", label: "桌球/桌游" },
    { value: "7933", label: "保龄球" },
    { value: "7941", label: "体育场馆" },
    { value: "7989", label: "网吧" },
    { value: "7990", label: "棋牌室" },
    { value: "7991", label: "展览和艺术场馆" },
    { value: "7992", label: "高尔夫球场" },
    { value: "7993", label: "家用电子游戏" },
    { value: "7994", label: "电玩娱乐场所" },
    { value: "7995", label: "彩票" },
    { value: "7996", label: "游乐园、马戏团、嘉年华" },
    { value: "7997", label: "健身和运动俱乐部" },
    { value: "7998", label: "动物园、水族馆" },
    { value: "7999", label: "其他娱乐服务" },
    { value: "8011", label: "诊所" },
    { value: "8021", label: "牙科医生" },
    { value: "8031", label: "正骨医生" },
    { value: "8041", label: "按摩医生" },
    { value: "8042", label: "眼科医疗服务" },
    { value: "8043", label: "眼镜店" },
    { value: "8050", label: "护理和照料服务" },
    { value: "8061", label: "民营医院" },
    { value: "8071", label: "医学及牙科实验室" },
    { value: "8099", label: "其他医疗保健服务" },
    { value: "8111", label: "法律咨询和律师事务所" },
    { value: "8241", label: "函授学校（成人教育）" },
    { value: "8244", label: "商业和文秘学校" },
    { value: "3007", label: "线下教培" },
    { value: "8641", label: "行业协会和专业社团" },
    { value: "8661", label: "宗教组织" },
    { value: "8675", label: "汽车协会" },
    { value: "8699", label: "其他会员组织" },
    { value: "8734", label: "测试实验服务" },
    { value: "8911", label: "建筑、工程和测量服务" },
    { value: "8912", label: "装修、装潢、园艺" },
    { value: "8931", label: "会计、审计、财务服务" },
    { value: "8999", label: "其他专业服务" },
    { value: "9400", label: "使领馆" },
    { value: "9402", label: "国家邮政" },
    { value: "9701", label: "Visa信任服务" },
    { value: "9702", label: "GCAS紧急服务（仅限Visa使用）" },
    { value: "0742", label: "兽医服务" },
    { value: "0743", label: "葡萄酒生产商" },
    { value: "0744", label: "其他酒类生产商" },
    { value: "0763", label: "农业合作与农具" },
    { value: "0780", label: "景观美化与园艺服务" },
    { value: "1780", label: "建筑工程" },
    { value: "6542", label: "房产租赁代理、经纪" },
    { value: "6015", label: "金融机构-还款类" },
    { value: "6400", label: "云闪付APP辅助类业务" },
    { value: "6500", label: "贷记业务转账" },
    { value: "6541", label: "融资租赁" },
    { value: "6761", label: "二维码转账" },
    { value: "9498", label: "信用卡还款" },
    { value: "9312", label: "房地产交易相关税费" },
    { value: "5040", label: "其他批发商（耐用品）" },
    { value: "5132", label: "其他批发商（非耐用品）" },

]
export { MCC }